import styled from 'styled-components';
import { theme } from '_constants/theme';
import { config } from '_config';
import * as React from 'react';
const { colors, devices, fontSizes, spaces } = theme;

const StyledWhatIsTrademarkMonitoringSection = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 100px;
  padding-bottom: 100px;
  @media ${devices.tablet} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;
const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  @media ${devices.tablet} {
    flex-direction: column;
    gap: 10px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const StyledLeftPart = styled.div`
  display: flex;
  flex-direction: column;
  color: #7b848d;
  font-size: 14px;
  font-family: 'MontserratRegular';
  line-height: 26px;
`;
const StyledLeftContainerColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  p {
    color: #7b848d;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.small}px;
    line-height: 20px;
    text-align: left;
  }
  img {
    min-width: 196px;
  }
  @media ${devices.tablet} {
    flex-direction: column;
  }
`;
const StyledRightContainerColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  p {
    color: #7b848d;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.small}px;
    line-height: 20px;
    text-align: left;
  }
  img {
    max-width: 200px;
  }
`;
const StyledSeparator = styled.div`
  background: #dee0e8;
  width: 1px;
`;
const StyledHeader = styled.div`
  color: #f37217;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  width: 100%;
  margin-bottom: 0.5rem;
  @media ${devices.tablet} {
    margin-bottom: 0px;
  }
`;
const StyledHeaderBlue = styled.div`
  color: #03589c;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: ${fontSizes.large4X}px;
  width: 100%;
  margin-bottom: 0.5rem;
  line-height: 30px;
  @media ${devices.tablet} {
    margin-bottom: 0px;
    font-size: ${fontSizes.largeX}px;
  }
`;
const WhatIsTrademarkMonitoringSection = () => {
  return (
    <StyledWhatIsTrademarkMonitoringSection>
      <StyledContainer>
        <StyledLeftContainerColumn>
          <img src={`${config.basePath}/shield.svg`} alt="" layout="fill" />
          <StyledLeftPart>
            <StyledHeaderBlue>What is Trademark Monitoring?</StyledHeaderBlue>{' '}
            Trademark monitoring is the process of overseeing and safeguarding
            your brand's intellectual property. It involves keeping a vigilant
            eye on trademarks to identify any potential infringements, ensuring
            that your brand remains unique and legally protected.
          </StyledLeftPart>
        </StyledLeftContainerColumn>
        <StyledSeparator />
        <StyledRightContainerColumn>
          <div>
            <StyledHeader>Services Offered by Trademark Genius</StyledHeader>
            <p>
              At Trademark Genius, we offer a comprehensive suite of services
              designed to shield your brand from any unauthorized usage. Our
              services encompass trademark searches, monitoring, and
              enforcement. We ensure that your brand's identity is preserved and
              unblemished.
            </p>
          </div>
          <div>
            <StyledHeader>
              Our team of legal experts and trademark professionals works
              diligently to:
            </StyledHeader>
            <p>
              Conduct thorough trademark searches to identify potential
              conflicts. Continuously monitor trademarks to detect any
              unauthorized usage. Implement legal actions to protect your brand,
              if necessary.
            </p>
          </div>
        </StyledRightContainerColumn>
      </StyledContainer>
    </StyledWhatIsTrademarkMonitoringSection>
  );
};

export default WhatIsTrademarkMonitoringSection;
